angular.module("infoOperative.components", [])
    .component("infoOperative", {
        templateUrl: "ng/components/riscattoAnticipato/infoOperative/infoOperative.view.html",
        bindings: {
            model: '<'
        },
        controller: InfoOperative,
        controllerAs: "infoOperativeCtrl"
    })

function InfoOperative() {

    var self = this;

    self.$onInit = function () {

        self.isElencoPuntato = true;


    }
}